import React from 'react';
import { PropTypes } from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { renderIf, isSome } from 'core/utils';
import { BaasicRecaptcha } from 'core/components';

const BasicFieldRecaptchaTemplate = defaultTemplate(({ field, t }) => {
    return (
        <div className="recaptcha">
            <label className="form__group__label" htmlFor={field.id}>{t(field.label)}</label>
            {renderIf(isSome(field.localizedError))(<div className="validation__message"> <i className="u-icon u-icon--xsml u-icon--warning u-mar--right--tny"></i>{field.localizedError}</div>)}
            <BaasicRecaptcha verifyCallback={(response) => field.set(response)} />
        </div>
    )
});

BasicFieldRecaptchaTemplate.propTypes = {
    field: PropTypes.any,
    t: PropTypes.func
}

export default BasicFieldRecaptchaTemplate;